/**
 * serviceOrderAddress - Validações dos campos extras do endereço de prestação da OS
 *
 * Espelham as regras do servidor (_service_order_validate v1.1.0 e CHECKs de
 * service_orders): o servidor é a barreira real; aqui só evitamos ida e volta.
 *
 * RELEASE: 2026-10-09 v1.0.0 - Versão inicial (referência, telefone e link do Google Maps).
 */

/** Link do Google Maps aceito (mesma allowlist do servidor). */
export const GOOGLE_MAPS_URL_RE = /^https:\/\/((www\.)?google\.com(\.[a-z]{2})?\/maps|maps\.google\.com(\.[a-z]{2})?|maps\.app\.goo\.gl|goo\.gl\/maps)([/?#][^\s<>"']*)?$/;
/** Telefone aceito: só números e símbolos de telefone, até 20 caracteres. */
export const ADDRESS_PHONE_RE = /^[0-9()+\-\s]{1,20}$/;

/**
 * Nome do contato no endereço: sem HTML e até 120 caracteres.
 * Espelha _service_order_validate v1.4.0; o servidor continua sendo a barreira real.
 * RELEASE: 2026-10-13 v1.2.0 - sanitizeAddressContactName.
 */
export function sanitizeAddressContactName(v: string): string {
  return v.replace(/[<>]/g, '').slice(0, 120);
}

/** Máscara simples de telefone BR: (00) 00000-0000 / (00) 0000-0000. */
export function maskPhone(v: string): string {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d ? `(${d}` : '';
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/**
 * Coordenadas do local coladas do Google Maps em um único campo ("-16.756515, -49.325765").
 * Espelha set_service_order_destination v1.0.0; o servidor continua sendo a barreira real.
 * RELEASE: 2026-10-13 v1.1.0 - parseCoordinates / formatCoordinates.
 */
export const COORDINATES_RE = /^-?\d{1,3}(\.\d+)?\s*,\s*-?\d{1,3}(\.\d+)?$/;

export function parseCoordinates(text: string): { lat: number; lng: number } | null {
  const value = text.trim();
  if (!value || value.length > 60 || !COORDINATES_RE.test(value)) return null;
  const [lat, lng] = value.split(',').map((part) => Number(part.trim()));
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { lat, lng };
}

/** Exibe no mesmo formato aceito pelo campo. */
export function formatCoordinates(lat?: number | null, lng?: number | null): string {
  return lat == null || lng == null ? '' : `${Number(lat)}, ${Number(lng)}`;
}
